export default __webpack_public_path__ + "static/media/github.736c8821.png";